import {DefaultLinkFactory} from "@projectstorm/react-diagrams";
import {NodeLinkModel} from "./NodeLinkModel";
import * as React from "react";
import {NodeLinkWidget} from "./NodeLinkWidget";
import {DataLinkSegment} from "./segments/DataLinkSegment";

export class NodeLinkFactory extends DefaultLinkFactory {
    constructor() {
        super('advanced'); // <-- this matches with the link model above
    }

    generateReactWidget(event: any): JSX.Element {
        return <NodeLinkWidget diagramEngine={this.engine} link={event.model}/>;
    }

    generateModel(): NodeLinkModel {
        return new NodeLinkModel(); // <-- this is how we get new instances
    }

    generateLinkSegment(model: NodeLinkModel, selected: boolean, path: string) {
        // FIREFOX SUPPORT USE THIS
        // return <path
        //     stroke={selected ? model.getOptions().selectedColor : model.getOptions().color}
        //     strokeWidth={model.getOptions().width}
        //     d={path}
        // />
        return <DataLinkSegment  model={model} path={path} selected={selected}/>;
    }
}
